_collow.components.AdminControlGroups = class AdminControlGroups extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;


    window.onload = this.handleLoad;

    this.getGroups();
    this.listen(elements.groupTopButton, "click", this.onClickGroupTopButton)
    this.listen(document, "_collow.overlay.clicked", () => this.showHidePopup(false));
    this.listen(elements.groupDeleteButton, "click", () => this.onClickGroupDeleteKebab())
    this.listen(elements.groupEditButton, "click", () => this.onClickGroupEditKebab())
    this.listen(elements.membersTopButton, "click", () => this.onClickManageMembers())
    this.listen(elements.coursesTopButton, "click", () => this.onClickManageCourses())

    this.listen(elements.groupSearch, "input", (event) => this.onSearch(event.target.value, "groups"));
    this.listen(elements.membersSearch, "input", (event) => this.onSearch(event.target.value, "members"));
    this.listen(elements.coursesSearch, "input", (event) => this.onSearch(event.target.value, "courses"));

    document.addEventListener("click", this.handleDocumentClick);
  }
  selectedGroup_id;
  allGroups = [];
  groupMembers = [];
  groupCourses = [];

  /**
   * Function to handle the load event
   * This function checks if the group was successfully edited or not
   * If it was successful, a success message is shown
   * If it was not successful, an info message is shown
   */
  handleLoad = () => {
    const edit_success = sessionStorage.getItem("group_edit_success");
    edit_success === "true" ? _collow.Notify.success(this.params.editSuccessMessage) : edit_success === "false" && _collow.Notify.info(this.params.editCancelledMessage);
    sessionStorage.removeItem("group_edit_success");
  }

  getGroups = async () => {
    const page = window.document.body
    page.classList.add("loading")

    const response = await fetch(this.params.path + "/admin/group/all", {
      method: "GET",
        headers: {
          Authorization: window.localStorage.getItem("token"),
        },
    });
    if (!response.ok) {
      console.error("Unable to fetch groups - msg: " + response)
    }
    const list_all_groups = await response.json()
    page.classList.remove("loading")

    this.allGroups = list_all_groups;
    this.displayGroupList(list_all_groups);
  }

  setHidden(element, hidden = true) {
    if (hidden) {
      if (!element.hasAttribute("hidden")) {
        element.setAttribute("hidden", "")
      }
    } else {
      if (element.hasAttribute("hidden")) {
        element.removeAttribute("hidden", "")
      }
    }
  }

  startCountdown = (textElement, duration = 5) => {
    return new Promise(resolve => {
      this.setHidden(textElement, false);
      let counter = duration;
      let originalText = textElement.textContent;

      const countdownLogic = () => {
        textElement.textContent = originalText.replace("{time}", counter);
        counter--;
        if (counter < 0) {
          clearInterval(countdown);
          this.setHidden(textElement, true);
          textElement.textContent = originalText;
          resolve();
        }
      };


      countdownLogic();
      let countdown = setInterval(countdownLogic, 1000);
    });
  }

  // Function to retrieve a list of the users and courses of a group
  getGroupUsersAndCourses = async (group_id) => {
    const page = window.document.body
    page.classList.add("loading")
    const baseUrl = this.params.path + `/admin/group`;
    const url = new URL(baseUrl);
    url.searchParams.append("group_id", group_id);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: window.localStorage.getItem("token"),
      },
    });
    if (!response.ok) {
      console.error("Unable to fetch groupExtendedInfo - msg: " + response)
    }
    const groupUsersAndCourse = await response.json()

    page.classList.remove("loading")

    return groupUsersAndCourse;
  }


  displayGroupList = (groups) => {
    const groupUL = this.elements.groupUl;
    groupUL.textContent = '';

    groups.forEach(group => {
      const newLi = this.getGroupLi(group);
      groupUL.appendChild(newLi);
    })
  };
  displayMembersList = (members) => {
    const membersUL = this.elements.membersUl;
    if(!members) {
      membersUL.textContent = '';
      return
    }
    membersUL.textContent = '';
    members.forEach(member => {
      membersUL.append(this.getLi(member))
    })
  }
  displayCoursesList = (courses) => {
    const coursesUL = this.elements.coursesUl;
    if(!courses) {
      coursesUL.textContent = '';
      return
    }
    coursesUL.textContent = '';
    courses.forEach(course => {
      coursesUL.append(this.getLi(course, false));
    })
  }

  // make a list item, that is clickable and has a 'kebab options function'
  getGroupLi = (group) => {
    const li = document.createElement('li')
    const groupName = document.createElement('span')
    const kebabOptionButton = document.createElement('button')
    const kebabOptionButtonIcon = document.createElement('span')
    kebabOptionButtonIcon.textContent = '⋮';
    kebabOptionButton.appendChild(kebabOptionButtonIcon);

    groupName.textContent = group.name
    li.appendChild(groupName);
    li.appendChild(kebabOptionButton);
    li.dataset.group_id = group.group_id;
    li.addEventListener("click", async (e) => {
      e.preventDefault();

      const siblings = li.parentElement.querySelectorAll('li.active');
      for (const sibling of siblings) {
        sibling.classList.remove('active');
      }
      li.classList.add('active');
      this.selectedGroup_id = li.dataset.group_id;
      await this.onClickGroup(li.dataset.group_id)
    })

    kebabOptionButton.addEventListener("click", (event) => this.onClickGroupKebab(event))

    return li;
  }
  // make a list item, without kebab or clickable
  getLi = (item, members=true) => {
    const li = document.createElement('li')
    const itemText = document.createElement('span')

    if(members) {itemText.textContent = this.fullname(item)}
    else {itemText.textContent = item.course_name}

    li.appendChild(itemText)
    return li;
  }

  fullname = (member) => {
    let name = member.firstname || member.email;
    
    if (member.firstname && member.lastname) {
      name += " " + member.lastname;
    }
    
    return name;
  };

  onClickGroup = async (group_id) => {
    const groupExtendedInfo = await this.getGroupUsersAndCourses(group_id);
    this.displayMembersList(groupExtendedInfo.users);
    this.displayCoursesList(groupExtendedInfo.courses);
    this.groupMembers = groupExtendedInfo.users;
    this.groupCourses = groupExtendedInfo.courses;

  }

  onClickGroupKebab = (event) => {
    event.stopPropagation()

    const kebabButton = event.currentTarget;
    const listItem = kebabButton.closest("li");
    if(!listItem) {
      console.error("Kebab button not found within a list item");
      return;
    }
    const groupId = listItem.dataset.group_id;

    this.selectedGroup_id = groupId;

    const kebabMenu = document.querySelector(".group-kebab-menu")
    const buttonRect = kebabButton.getBoundingClientRect();
    kebabMenu.style.top = `${buttonRect.bottom}px`;
    kebabMenu.style.left = `${buttonRect.right}px`;

    kebabMenu.toggleAttribute("hidden")
    this.kebabMenuVisible = !kebabMenu.hasAttribute("hidden");

  }

  onClickManageMembers = () => {
    if (this.selectedGroup_id) {
      window.location.href = '/group/members?group_id=' + this.selectedGroup_id;
    }
  }

  onClickManageCourses = () => {
    if (this.selectedGroup_id) {
      window.location.href = '/group/courses?group_id=' + this.selectedGroup_id;
    }
  }

  onClickGroupTopButton = () => {
    window.location.href = '/group/create';
  }

  onClickGroupEditKebab = () => {
    const groupId = this.selectedGroup_id;

    const listItem = document.querySelector(`li[data-group_id="${groupId}"]`);
    if (!listItem) {
      console.error("List item not found");
      return;
    }

    const originalGroup = {
      name: listItem.querySelector('span').textContent,
      group_id: groupId
    };

    const editContainer = document.querySelector(".edit-group-name-input").cloneNode(true);
    editContainer.removeAttribute("hidden");
    const input = editContainer.querySelector("input");
    const saveButton = editContainer.querySelector("button:nth-child(2)");
    const cancelButton = editContainer.querySelector("button:nth-child(3)");

    input.value = originalGroup.name

    saveButton.addEventListener('click', () => {
      this.editGroupName(groupId, input.value);
    });

    cancelButton.addEventListener('click', () => {
      this.deselectAll();
      const newLi = this.getGroupLi(originalGroup);
      listItem.replaceWith(newLi)
    });

    listItem.innerHTML = '';
    listItem.appendChild(editContainer);

    input.focus();
  }

  onClickGroupDeleteKebab = async () => {
    this.showHidePopup(true)
    this.dispatch(this.root, "_collow.popup", { type: "open" });
    this.elements.deletePopupConfirm.toggleAttribute("disabled", true);

    this.setHidden(this.elements.deleteGroupTimerConfirmation, true);
    await this.startCountdown(this.elements.deleteGroupTimer, 5);
    this.elements.deletePopupConfirm.toggleAttribute("disabled", false);
    this.setHidden(this.elements.deleteGroupTimerConfirmation, false);
  }

  deselectAll = () => {
    this.dispatch(this.root, "_collow.popup", { type: "close" });
    this.selectedGroup_id = null;

    const kebabMenu = document.querySelector(".group-kebab-menu")
    if (!kebabMenu.hasAttribute("hidden")) {
      kebabMenu.setAttribute("hidden", "")
    }
    if(!this.elements.deletePopup.hasAttribute("hidden")) {
      this.elements.deletePopup.setAttribute("hidden", "")
    }

  };

showHidePopup = (state = false) => {
  if (state) {
    this.elements.deletePopup.removeAttribute("hidden")
    this.listen(this.elements.deletePopupConfirm, "click", this.deleteGroup);
    this.listen(this.elements.deletePopupCancel, "click", () => this.showHidePopup(false));
  } else {
    this.unlisten(this.elements.deletePopupConfirm, "click", this.deleteGroup);
    this.unlisten(this.elements.deletePopupCancel, "click", this.showHidePopup);
    this.deselectAll();
  }
};

  deleteGroup = async () => {
    try {
      const url = `${this.params.path}/admin/group?group_id=${this.selectedGroup_id}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        console.error(response);
      } else {
        const responseJson = response.json();
        this.showHidePopup(false)
        this.getGroups();
        this.displayMembersList()
        this.displayCoursesList()
      }
    } catch (error) {
      console.error("deleteGroup: " + error)
    }
  };

  editGroupName = async (group_id, newGroupName) => {
    const formdata = new FormData()
    formdata.append("group_id", group_id);
    formdata.append("name", newGroupName);

    try {
      const response = await fetch(this.params.path + "/admin/group", {
        method: "PUT",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        body: formdata
      });

      if (!response.ok) {
        console.error(response);
      } else {
        const responseJson = response.json();

        this.deselectAll();
        this.getGroups();
      }
    } catch (error) {
      console.error("editGroupName catch:" + error)
    }
  }

  onSearch = (query, type) => {
    // Convert the search query to lower case to ensure case insensitive matching
    query = query.toLowerCase();

    // Use a switch statement to handle different types of searches based on the 'type' parameter
    switch (type) {
      case "groups":
        // Filter 'allGroups' to find groups whose name includes the search query
        const filteredGroups = this.allGroups.filter(group =>
          group.name.toLowerCase().includes(query)
        );
        // Call displayGroupList to update the UI with the filtered groups
        this.displayGroupList(filteredGroups);
        break;
      case "members":
        // Filter 'groupMembers' to find members whose name includes the search query
        const filteredMembers = this.groupMembers.filter(member => {
          const fullName = this.fullname(member).toLowerCase().replace(/\s+/g, ' ').trim();
          return fullName.includes(query);
        });

        this.displayMembersList(filteredMembers);
        break;
      case "courses":
        // Filter 'groupCourses' to find courses whose course name includes the search query
        const filteredCourses = this.groupCourses.filter(course =>
          course.course_name.toLowerCase().includes(query)
        );
        this.displayCoursesList(filteredCourses);
        break;
    }
  }

  handleDocumentClick = () => {
    if (this.kebabMenuVisible) {
      const kebabMenu = document.querySelector(".group-kebab-menu");
      kebabMenu.setAttribute("hidden", "");
      this.kebabMenuVisible = false;
    }
  }
};
